module.exports = __webpack_public_path__ + "static/night_hag-3c948de40629a736aa4a74481630c318.jpeg";